module.exports = __webpack_public_path__ + "a1ff80ff355e0ee97a86e9f5db04cf0f.MP3";